<router-outlet></router-outlet>
<footer class="public-legal">
  <app-footer [publicMode]="true"></app-footer>
</footer>
